import cx from 'classnames';
import React from 'react';
import { getIconBaseUrl } from '../../../utils/assets';
import Heading from '../../Heading';
import styles from '../popup.module.scss';
import basic from './basic.module.scss';
const BasicPopup = ({ name, children, onClose, className, disableClose, }) => (<>
    <div className={cx(styles.popup, className)} data-testid='popup'>
      <div className={styles.popupHeader}>
        <Heading className={basic.popupName}>{name}</Heading>
        {!disableClose && (<button className={cx(styles.popupClose, basic.popupClose)} type='button' onClick={onClose}>
            <img src={getIconBaseUrl('close.svg')} alt='Close popup'/>
            <span className='srOnly'>Close</span>
          </button>)}
      </div>
      <div className={styles.popupContent} data-testid='popupContent'>
        {children}
      </div>
    </div>
    <div className={styles.popupHood}>
      {!disableClose && (<button type='button' onClick={onClose}>
          Close
        </button>)}
    </div>
  </>);
export default BasicPopup;
